import { Navigate } from 'react-router'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import SupportTwoFactorGate from './components/twoFactor/SupportTwoFactorGate'

export default function SupportPortalProtectedRoute({ children }) {
  const authoritiesInBoolean = getAllRolesInBoolean()

  // Check for all Support Portal roles
  if (
    !authoritiesInBoolean.isL1TherapySupport &&
    !authoritiesInBoolean.isL2TherapySupport &&
    !authoritiesInBoolean.isL3TherapySupport &&
    !authoritiesInBoolean.isTherapistAdmin &&
    !authoritiesInBoolean.isClinicRosterManager &&
    !authoritiesInBoolean.isClinicRosterAdmin &&
    !authoritiesInBoolean.isClinicSuccessManager &&
    !authoritiesInBoolean.isClinicSuccessAdmin &&
    !authoritiesInBoolean.isSupport &&
    !authoritiesInBoolean.isSupportUser &&
    !authoritiesInBoolean.isPaymentSupport &&
    !authoritiesInBoolean.isManagement &&
    !authoritiesInBoolean.isVcAuditAdmin &&
    !authoritiesInBoolean.isVcAuditManager &&
    !authoritiesInBoolean.isDocSideAdmin
  ) {
    return <Navigate to="/" />
  }
  return <SupportTwoFactorGate>{children}</SupportTwoFactorGate>
}
